/*                                                  */
/*                                                           */

import { core } from '@otto-ec/global-resources/core';

export const HEUREKA_FILTERSHEET_FRAGMENT = '#oc-sheet-v1=heureka-filtersheet';

type QueryParamKey = string;
type QueryParamValue = undefined | string | number | boolean | (string | number | boolean)[];
type Page = {
    sortiertnach?: string;
    l?: string;
    o?: string;
    c?: string;
};

/**
 *
 *
 *
 *
 *
 *
 *
 */
function parseQueryParams(queryString: string) {
    const params: Record<QueryParamKey, QueryParamValue> = {};

    queryString
        .split('&')
        .filter((chunk) => chunk !== '')
        .forEach((chunk) => {
            const splittedChunk = chunk.split('=');
            const key = splittedChunk[0];
            if (splittedChunk.length > 1) {
                const valArray = (splittedChunk[1] || '').split(',').map((val) => core.coerce(val));
                params[key] = valArray.length === 1 ? valArray[0] : valArray;
            } else {
                params[key] = undefined;
            }
        });
    return params;
}

/**
 *
 *
 *
 *
 *
 *
 */
function formatQueryParams(obj: Record<string, QueryParamValue>) {
    return Object.keys(obj)
        .map((key) => {
            if (obj[key] === undefined) {
                return key;
            } else {
                const objKey = obj[key] || [];
                const objKeyAsArray = Array.isArray(objKey) ? objKey : [objKey];
                return `${key}=${objKeyAsArray.join(',')}`;
            }
        })
        .join('&');
}

/**
 *
 *
 *
 */
export function getQuery(queryString: string) {
    const { o, l, sortiertnach, c, ...parameters } = parseQueryParams(queryString.slice(1));
    return {
        parameters: parameters,
        page: {
            o: o,
            l: l,
            sortiertnach: sortiertnach,
            c: c,
        },
    };
}

/**
 *
 *
 *
 *
 *
 */
export function isSamePage(currentPage: Page, historyPage: Page): boolean {
    return (
        currentPage.l === historyPage.l &&
        currentPage.sortiertnach === historyPage.sortiertnach &&
        currentPage.o === historyPage.o
    );
}

/**
 *
 *
 *
 *
 */
export function pagedUrl(page: Page, path: string, queryParams: string): string {
    const queryString = formatQueryParams({
        ...getQuery(queryParams).parameters,
        ...page,
    });

    return queryString ? `${path}?${queryString}` : path;
}

export function setLocation(target: string | undefined) {
    if (target == undefined) {
        return;
    }
    window.location.href = target;
}

/*                                     */
/**
 *
 *
 *
 *
 */
export function clean(object: object): object {
    const clonedObject = { ...object };

    [].forEach.call(
        Object.keys(clonedObject),
        (key) =>
            (clonedObject[key] === '' || clonedObject[key] == null || clonedObject[key] === undefined) &&
            delete clonedObject[key],
    );

    return clonedObject;
}

export function appendHeurekaFragment(url: string): string {
    if (url.includes('#') || window.location.hash !== HEUREKA_FILTERSHEET_FRAGMENT) {
        return url;
    }

    return `${url}${HEUREKA_FILTERSHEET_FRAGMENT}`;
}
